export const JP_DATE_DISPLAY = 'YYYY年M⽉D⽇';
export const JP_DATE_SHORT_DISPLAY = 'M月D⽇';
export const JP_TIME_DISPLAY = 'M月D⽇ HH:mm';
export const DATE_API = 'YYYY-MM-DD';
export const JP_MONTH_DISPLAY = 'YYYY年MM月';
export const DATE_DISPLAY_HOME = 'YYYY/MM/DD';
export const DATE_TIME_DISPLAY = 'YYYY/MM/DD HH:mm:ss';
export const DAY_TIME_DISPLAY = 'MM/DD HH:mm';
